import { ApiDetails } from "./config.interfaces";

export const api: ApiDetails = {
  base: "/api/",
  key: "eKabd7G;bd",
  suffixSplitChars: ["%", ".", ","],
};
